import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import DashboardFooter from "./DashboardFooter";
import "../css/Dashboard.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaUsers,
  FaUserTie,
  FaLayerGroup,
  FaListAlt,
  FaUserGraduate,
  FaChartLine,
} from "react-icons/fa";

const API_BASE = "https://auxititpt.org/Backend";

const Dashboard = () => {
  const [stats, setStats] = useState({
    students: 0,
    staff: 0,
    trades: 0,
    departments: 0,
    loading: true,
  });

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [studentRes, staffRes, tradeRes] = await Promise.all([
        fetch(`${API_BASE}/student_api.php`),
        fetch(`${API_BASE}/staff_api.php`),
        fetch(`${API_BASE}/trade_api.php`),
      ]);

      const [students, staff, trades] = await Promise.all([
        studentRes.json(),
        staffRes.json(),
        tradeRes.json(),
      ]);

      setStats({
        students: Array.isArray(students) ? students.length : 0,
        staff: Array.isArray(staff) ? staff.length : 0,
        trades: Array.isArray(trades) ? trades.length : 0,
        departments: 4, // Placeholder — replace with real endpoint if you have one
        loading: false,
      });
    } catch (error) {
      console.error("Dashboard fetch error:", error);
      setStats((p) => ({ ...p, loading: false }));
    }
  };

  const StatCard = ({ title, value, icon, color }) => (
    <div className="col-md-3 col-sm-6">
      <div className="card dashboard-card shadow-sm border-0 text-center p-4">
        <div className={`mb-3 text-${color}`} style={{ fontSize: "2rem" }}>
          {icon}
        </div>
        <h6 className="text-uppercase text-muted">{title}</h6>
        {stats.loading ? (
          <div className="spinner-border spinner-border-sm text-secondary mt-2" />
        ) : (
          <h2 className="fw-bold mt-1">{value}</h2>
        )}
      </div>
    </div>
  );

  return (
    <div className="d-flex dashboard-container">
      <Sidebar />

      <div className="main-content flex-grow-1">
        <Header />

        <div className="container-fluid py-4">
          <h4 className="fw-bold mb-4">
            Welcome back, <span className="text-primary">Admin</span>
          </h4>

          {/* Dynamic Stat Cards */}
          <div className="row g-4">
            <StatCard
              title="Students"
              value={stats.students}
              icon={<FaUserGraduate />}
              color="primary"
            />
            <StatCard
              title="Staff"
              value={stats.staff}
              icon={<FaUserTie />}
              color="success"
            />
            <StatCard
              title="Trades"
              value={stats.trades}
              icon={<FaLayerGroup />}
              color="warning"
            />
            <StatCard
              title="Departments"
              value={stats.departments}
              icon={<FaListAlt />}
              color="danger"
            />
          </div>

          {/* Extra section: trends (optional placeholder) */}
          <div className="card shadow-sm mt-5 p-4">
            <div className="d-flex align-items-center justify-content-between">
              <h5 className="fw-bold">
                <FaChartLine className="me-2 text-primary" />
                Overview
              </h5>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={fetchDashboardData}
              >
                Refresh Data
              </button>
            </div>
            <hr />
            <p className="text-muted mb-0">
              This dashboard gives a quick snapshot of the institution’s data —
              including students, trades, and staff counts. Future updates can
              include charts, progress analytics, and reports.
            </p>
          </div>
        </div>

        <DashboardFooter />
      </div>
    </div>
  );
};

export default Dashboard;
